import { defineMessages } from 'react-intl';

export const appUpdateMessages = defineMessages({
  title: { id: 'app.sml.appUpdate.title', defaultMessage: 'A new version of MUSIC24 is ready' },
  body: {
    id: 'app.sml.appUpdate.body',
    defaultMessage: 'Refresh the page to get it. Save your changes first.',
  },
  refresh: { id: 'app.sml.appUpdate.refresh', defaultMessage: 'Refresh' },
});
